import { useState } from "react";
import { Button, Card, showToast } from "@xpense/ui";
import { api } from "../api/client";

export default function Login() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleGoogleLogin = async () => {
    setLoading(true);
    setError("");
    try {
      const redirectUri = `${window.location.origin}/auth/google/callback`;
      const response = await api.get<{ url: string; state: string }>(
        `/api/v1/auth/google/url?redirect_uri=${encodeURIComponent(redirectUri)}`
      );
      window.location.href = response.url;
    } catch (err) {
      const msg = err instanceof Error ? err.message : "Failed to start Google login";
      setError(msg);
      showToast(msg, "error");
      setLoading(false);
    }
  };

  return (
    <div className="xpn-login-shell xpn-fade-in">
      <section className="xpn-login-art" aria-label="Xpense AI product preview">
        <div className="xpn-brand" style={{ marginBottom: 0 }}>
          <div className="xpn-brand-mark">X</div>
          <div>
            <div className="xpn-brand-title" style={{ color: "var(--xpn-text)" }}>
              Xpense AI
            </div>
            <div className="xpn-brand-subtitle" style={{ color: "var(--xpn-text-muted)" }}>
              India-first expense intelligence
            </div>
          </div>
        </div>

        <div>
          <div className="xpn-page-eyebrow">AI-first finance ops</div>
          <h1 className="xpn-page-title" style={{ maxWidth: 620 }}>
            Turn raw SMS and notifications into a clean financial command center.
          </h1>
          <p className="xpn-page-description">
            Confidence gates, review queues, monthly insights, and forecasts built for everyday Indian spending patterns.
          </p>
        </div>

        <div className="xpn-login-preview">
          <div className="xpn-login-preview-header">
            <div>
              <div className="xpn-text-caption xpn-text-muted">Projected monthly spend</div>
              <div data-tnum className="xpn-text-display-md xpn-text">
                Rs 42,800
              </div>
            </div>
            <div className="xpn-badge xpn-badge--success">92% confidence</div>
          </div>
          <div className="xpn-section-body">
            {[
              ["Food & Dining", "Rs 12,400", "64%"],
              ["Transport", "Rs 6,900", "36%"],
              ["Investments", "Rs 8,000", "48%"],
            ].map(([label, amount, width]) => (
              <div className="xpn-category-row" key={label}>
                <div>
                  <div className="xpn-flex-between xpn-mb-xs">
                    <span className="xpn-text-body-md xpn-text" style={{ fontWeight: 650 }}>
                      {label}
                    </span>
                    <span className="xpn-text-caption-tabular xpn-text-muted">{amount}</span>
                  </div>
                  <div className="xpn-progress">
                    <div className="xpn-progress-bar" style={{ width }} />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <main className="xpn-login-panel">
        <Card className="xpn-auth-card">
          <div className="xpn-text-center xpn-mb-2xl">
            <div className="xpn-brand-mark" style={{ margin: "0 auto var(--xpn-space-md)" }}>
              X
            </div>
            <h1 className="xpn-text-display-lg xpn-text">Welcome back</h1>
            <p className="xpn-text-body-md xpn-text-muted">
              Continue with Google to create or open your Xpense workspace.
            </p>
          </div>

          <Button fullWidth onClick={handleGoogleLogin} loading={loading}>
            <span aria-hidden="true" style={{ fontWeight: 750 }}>
              G
            </span>
            Continue with Google
          </Button>

          {error && (
            <div
              style={{
                marginTop: "var(--xpn-space-lg)",
                padding: "var(--xpn-space-md)",
                background: "var(--xpn-color-danger-bg)",
                color: "var(--xpn-color-danger)",
                borderRadius: "var(--xpn-radius-lg)",
                fontSize: 14,
              }}
            >
              {error}
            </div>
          )}
        </Card>
      </main>
    </div>
  );
}
